'use client'

import { cn } from '@/lib/utils'
import { memo, useCallback } from 'react'

type CategoryItemProps = {
  active?: boolean
  category: string
  className?: string
  onSelect?: (category: string) => void
}

function CategoryItem({ active = false, category, className = '', onSelect }: CategoryItemProps) {
  const handleSelect = useCallback(() => {
    onSelect && onSelect(category)
  }, [category, onSelect])

  return (
    <button
      type="button"
      aria-pressed={active}
      className={cn(
        'font-space-grotesk flex h-[40px] cursor-pointer items-center justify-center gap-x-1 truncate rounded-2xl px-3 py-0 text-sm font-medium text-black transition-all duration-200',
        active
          ? 'border border-black/10 bg-white/80 shadow-none'
          : 'border border-transparent bg-transparent',
        'hover:border-black/20 hover:bg-white/90 focus-visible:border-black/20 focus-visible:bg-white/90 focus-visible:outline-none',
        className
      )}
      onClick={handleSelect}
    >
      {category}
    </button>
  )
}

export default memo(CategoryItem)
